import { Badge } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';

interface UnlistedVehiclesCardProps {
  data?: any;
}

const UnlistedVehiclesCard = ({ data }: UnlistedVehiclesCardProps) => {
  const totalVehiclesInHousehold = data.summary?.totalVehiclesInHousehold || 0;
  const totalVehiclesOnApplication =
    data?.summary?.totalVehiclesOnApplication || 0;

  const formatVehicleCount = (count: number | string) => {
    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {count || 0}
      </Badge>
    );
  };

  const headers = [
    'Total number of automobiles in the household or business (App)',
    'Total number of vehicles on application',
    'Total number of vehicles listed in the prior 12 months',
  ];

  const rows = [
    [
      formatVehicleCount(totalVehiclesInHousehold),
      formatVehicleCount(totalVehiclesOnApplication),
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {data.summary.totalVehiclesListed12Months}
      </Badge>,
    ],
  ];

  return (
    <DataTableCard
      description="Check to account for any vehicles not listed on application."
      headers={headers}
      rows={rows}
    />
  );
};

export default UnlistedVehiclesCard;
